var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M16.5858 3H21V5H17.4142L17.1232 5.29104L18.7563 11.0072C21.1224 11.14 23 13.1008 23 15.5C23 17.9853 20.9853 20 18.5 20C16.0147 20 14 17.9853 14 15.5C14 13.6268 15.1445 12.0209 16.7724 11.3436L16.4548 10.232L9.90913 14.5958C9.96871 14.8879 10 15.1903 10 15.5C10 17.9853 7.98528 20 5.5 20C3.01472 20 1 17.9853 1 15.5C1 13.0147 3.01472 11 5.5 11C5.62604 11 5.75087 11.0052 5.87428 11.0153L7.38195 8H5V6H9L10 7V8H15.8171L14.8768 4.70896L16.5858 3ZM7.8018 11.6324C8.29065 11.924 8.71956 12.3056 9.06564 12.7544L13.1973 10H8.61802L7.8018 11.6324ZM8 15.5C8 16.8807 6.88071 18 5.5 18C4.11929 18 3 16.8807 3 15.5C3 14.1193 4.11929 13 5.5 13C6.88071 13 8 14.1193 8 15.5ZM18.5 18C19.8807 18 21 16.8807 21 15.5C21 14.1193 19.8807 13 18.5 13C17.1193 13 16 14.1193 16 15.5C16 16.8807 17.1193 18 18.5 18Z'
      })
    ),
    props
  );
}

module.exports = Icon;
